const frTranslations = {
  // =========================
  // NAVIGATION
  // =========================
  "floating.contact": "Contactez-nous",
  "floating.phone": "Téléphone :",
  "header.about": "À propos",
  "header.careers": "Carrières",
  "header.construction": "BTP",
  "header.contact": "Contact",
  "header.home": "Accueil",
  "header.mining": "Mines",
  "header.realEstate": "Promotion Immobilière",
  "language.en": "English",
  "language.fr": "Français",

  // =========================
  // HOME
  // =========================
  "home.chiffres.collaborateurs": "Collaborateurs",
  "home.chiffres.collaborateursLabel": "Collaborateurs\n(Siège + chantiers)",
  "home.chiffres.filiales": "Filiales",
  "home.chiffres.filialesLabel": "Filiales : Keur Invest\n& SOCABEG Mining",
  "home.chiffres.highlight": "NOTRE IMPACT",
  "home.chiffres.parcelles": "Parcelles",
  "home.chiffres.parcellesLabel": "Parcelles viabilisées\net logements livrés",
  "home.chiffres.patrimoine": "De patrimoine foncier",
  "home.chiffres.patrimoineLabel": "Hectares de\npatrimoine foncier",
  "home.chiffres.title": "CHIFFRES-CLÉS",
  "home.chiffres.voiries": "Voiries et réseaux\ndivers réalisés",
  "home.hero.contact": "Nous contacter",
  "home.hero.description": "Acteur majeur au Sénégal dans les domaines du BTP, de la promotion immobilière et des mines.",
  "home.hero.highlight": "Bâtir le Sénégal durablement",
  "home.hero.slides.slide1.subtitle": "Plus de 5 000 logements livrés à travers le pays, façonnant ainsi le paysage urbain sénégalais depuis 1986.",
  "home.hero.slides.slide1.title": "Leader dans la construction de logements sociaux au Sénégal",
  "home.hero.slides.slide2.subtitle": "Notre priorité : simplifier l’acquisition de propriétés pour nos partenaires avec des solutions clés en main.",
  "home.hero.slides.slide2.title": "Innover et bâtir : notre passion au service de vos projets",
  "home.hero.slides.slide3.subtitle": "Engagés pour un avenir durable et qualitatif, où l’harmonie environnementale enrichit notre communauté.",
  "home.hero.slides.slide3.title": "Des valeurs fortes pour construire durablement votre patrimoine",
  "home.hero.title": "BIENVENUE CHEZ SOCABEG",
  "home.metiers.btp.description": "Concevoir et construire des espaces de vie qui inspirent et connectent.",
  "home.metiers.btp.title": "BTP",
  "home.metiers.description": "Explorez nos secteurs du BTP, de l’immobilier et des mines, qui contribuent à façonner un Sénégal innovant et durable.",
  "home.metiers.discover": "Voir plus",
  "home.metiers.highlight": "DES MÉTIERS COMPLÉMENTAIRES, UNE VISION COMMUNE",
  "home.metiers.immobilier.description": "Des réalisations harmonieuses où l’investissement concrétise un rêve et un patrimoine durable.",
  "home.metiers.immobilier.title": "Promotion Immobilière",
  "home.metiers.mines.description": "Au cœur de l'innovation minière : Des ressources qui forgent le progrès",
  "home.metiers.mines.title": "Mines",
  "home.metiers.title": "NOS MÉTIERS",
  "home.partners.description": "SOCABEG collabore avec des institutions et entreprises de premier plan pour offrir l’excellence dans tous nos projets.",
  "home.partners.highlight": "ENSEMBLE, NOUS CRÉONS DES OPPORTUNITÉS",
  "home.partners.list": [
    {
      "id": 1,
      "name": "BHS",
      "logo": "/images/partners/bhs.png",
      "url": "#"
    },
    {
      "id": 2,
      "name": "GEOPLAST",
      "logo": "/images/partners/geoplast.png",
      "url": "#"
    },
    {
      "id": 3,
      "name": "IPRES",
      "logo": "/images/partners/ipres.jpg",
      "url": "#"
    },
    {
      "id": 4,
      "name": "SAR",
      "parking": "Places de parking",
      "superficie": "Superficie",
      "naturePapier": "Nature Papier",
      "statut": "Statut",
      "surface": "Surface",
      "logo": "/images/partners/sar.png",
      "url": "#"
    },
    {
      "id": 5,
      "name": "SGS",
      "logo": "/images/partners/sgs.png",
      "url": "#"
    },
    {
      "id": 6,
      "name": "SICAP",
      "logo": "/images/partners/sicap.jpg",
      "url": "#"
    },
    {
      "id": 7,
      "name": "SN",
      "logo": "/images/partners/sn.jpg",
      "url": "#"
    },
    {
      "id": 8,
      "name": "SNHLM",
      "logo": "/images/partners/snhlm.jpg",
      "url": "#"
    },
    {
      "id": 9,
      "name": "SONATEL",
      "logo": "/images/partners/sonatel.png",
      "url": "#"
    }
  ],
  "home.partners.title": "NOS PARTENAIRES",
  "home.projects.highlight": "PROGRAMMES À LA UNE",
  "home.projects.title": "NOS RÉALISATIONS",
  "home.testimonials.client1.name": "Amadou DIALLO",
  "home.testimonials.client1.position": "Entrepreneur",
  "home.testimonials.client1.quote": "J’ai pu diversifier mon portefeuille immobilier en quelques années grâce à la variété de leurs offres, ce qui m’a permis d’atteindre mes objectifs financiers avec succès.",
  "home.testimonials.client2.name": "Marie SÈNE",
  "home.testimonials.client2.position": "Commerçante",
  "home.testimonials.client2.quote": "En tant que vendeuse, le format de paiement flexible sur certains programmes de SOCABEG m’a été d’un grand soutien. J’ai pu acquérir des biens sans passer par les institutions bancaires, ce qui fut un véritable soulagement.",
  "home.testimonials.client3.name": "Ibrahima NDIAYE",
  "home.testimonials.client3.position": "Dentiste",
  "home.testimonials.client3.quote": "Investir chez SOCABEG a été une expérience extrêmement enrichissante. Ne sachant pas par où commencer pour acquérir un terrain, ils m’ont proposé des opportunités que je n’aurais jamais découvertes seul. Je recommande vivement leurs services.",
  "home.testimonials.client4.name": "Moussa TRAORÉ",
  "home.testimonials.client4.position": "Retraité",
  "home.testimonials.client4.quote": "Étant en location depuis plusieurs années, j’ai travaillé dur pour offrir un toit à ma famille. Ce rêve s’est concrétisé grâce à un programme de logement proposé par SOCABEG. Leur accompagnement a été précieux à chaque étape.",
  "home.testimonials.client5.name": "Papa Moussa FALL",
  "home.testimonials.client5.position": "Professeur",
  "home.testimonials.client5.quote": "Je suis finalement satisfait de la transparence et de l’engagement de SOCABEG. Ils ont su transformer une longue attente en une expérience agréable, malgré quelques contraintes qui ont impacté la livraison du projet.",
  "home.testimonials.client6.name": "TOIT IMMO",
  "home.testimonials.client6.position": "Agence immobilière",
  "home.testimonials.client6.quote": "En tant que partenaire, nous avons pu concrétiser un projet de viabilisation et de construction avec SOCABEG. La qualité de la collaboration a été très appréciée.",
  "home.testimonials.client7.name": "COHMECPN",
  "home.testimonials.client7.position": "Coopérative d'habitat",
  "home.testimonials.client7.quote": "Notre coopérative a trouvé chez SOCABEG un partenaire fiable et compétent pour la réalisation de nos projets de logements sociaux. Leur expertise dans le domaine de l'habitat coopératif et leur engagement aux côtés des membres nous ont permis de concrétiser des projets de qualité pour nos adhérents.",
  "home.testimonials.description": "Découvrez ce que nos clients et partenaires disent de leur expérience avec SOCABEG.",
  "home.testimonials.highlight": "ILS NOUS FONT CONFIANCE",
  "home.testimonials.title": "TÉMOIGNAGES",
  "home.whoareus.description": "SOCABEG s’investit aux côtés des Sénégalais pour réaliser leurs projets immobiliers.",
  "home.whoareus.engagement1": "Fondée en 1986 par M. Mamoune SAMB, SOCABEG s'est imposée comme un acteur majeur reconnu dans le domaine de la construction et de la promotion immobilière au Sénégal. Le Groupe SOCABEG exerce aujourd'hui ses activités dans les domaines du BTP, de la Promotion immobilière et le secteur minier.",
  "home.whoareus.engagement2": "Elle dispose d'une très grande notoriété dans le paysage des affaires au Sénégal rassemblant les compétences de constructeur bien équipé et aménageur de site avec un très riche savoir-faire acquis dans l'habitat social. SOCABEG a une forte maîtrise de la chaîne de valeur en tant que développeur-constructeur avec une offre verticalisée et une gamme de produits en adéquation avec le marché immobilier sénégalais.",
  "home.whoareus.engagement3": "L'entreprise a achevé avec succès de nombreux projets de logements, de lotissements de terrains à bâtir, la construction de bureaux administratifs, complexes résidentiels, de bâtiments publics pour le compte d'institutions publics, de coopératives d'habitats et de clients privés. Ces réalisations ont renforcé notre réputation.",
  "home.whoareus.engagement4": "Elle promeut la réalisation et l'aménagement d'écoquartiers résidentiels et de loisirs, de bâtiments vertueux pour une meilleure qualité de vie, dans un environnement éco-responsable au bénéfice de ses clients. Elle reste ancrée dans ses valeurs fondamentales : l'intégrité, la recherche de la qualité, l'innovation et la responsabilité sociale, qui guident toutes ses activités et décisions.",
  "home.whoareus.engagement5": "En proposant des projets immobiliers novateurs et de qualité, accessibles à un coût raisonnable, elle vise à allier excellence de construction et accessibilité financière. SOCABEG a joué un rôle clé dans l'essor de nouvelles zones urbaines en construisant des milliers de logements, répondant ainsi aux besoins d'une large part de la population sénégalaise aux revenus variés.",
  "home.whoareus.highlight": "DEPUIS PLUS DE 40 ANS À VOTRE SERVICE",
  "home.whoareus.title": "QUI SOMMES-NOUS",
  "home.why.advantage1.description": "Plus de 40 ans d'activité dans le BTP et l'immobilier au Sénégal, avec des milliers de logements livrés.",
  "home.why.advantage1.title": "Expérience reconnue",
  "home.why.advantage2.description": "Une expertise complète du cycle de construction : études, réalisation, viabilisation, commercialisation.",
  "home.why.advantage2.title": "Maîtrise des projets",
  "home.why.advantage3.description": "Techniques modernes à faible empreinte carbone et formation de la main-d’œuvre locale.",
  "home.why.advantage3.title": "Responsabilité durable",
  "home.why.advantage4.description": "BIM, ERP BTP, coffrages Geoplast®, usine de préfabrication… SOCABEG investit dans la modernité.",
  "home.why.advantage4.title": "Innovation technique",
  "home.why.advantage5.description": "Tivaouane Peulh, HLM Castor, Darou Salam, Cité IPRES… des projets qui transforment la ville.",
  "home.why.advantage5.title": "Projets emblématiques",
  "home.why.advantage6.description": "Entreprise 100 % sénégalaise à taille humaine, proche de ses clients et de leurs besoins.",
  "home.why.advantage6.title": "Confiance et proximité",
  "home.why.description": "Découvrez les nombreux avantages qui font de SOCABEG un partenaire de confiance pour vos projets.",
  "home.why.highlight": "NOTRE VALEUR AJOUTÉE",
  "home.why.innovation.description": "Nous innovons en permanence pour offrir des solutions de pointe à nos clients.",
  "home.why.innovation.title": "Innovation",
  "home.why.quality.description": "Nous nous engageons à fournir des services de haute qualité qui répondent aux normes les plus élevées.",
  "home.why.quality.title": "Qualité",
  "home.why.sustainability.description": "Nous intégrons le développement durable dans tous nos projets pour un avenir meilleur.",
  "home.why.sustainability.title": "Durabilité",
  "home.why.title": "POURQUOI NOUS CHOISIR",
  "home.why.trust.description": "Nous construisons des relations durables basées sur la confiance et la transparence avec nos clients.",
  "home.why.trust.title": "Confiance",

  // =========================
  // ABOUT
  // =========================
  "about.engagement.mission.paragraph1": "Fournir des services de construction de haute qualité pour répondre aux besoins de nos clients tout en respectant les normes de sécurité, de durabilité et d’efficacité.",
  "about.engagement.mission.paragraph2": "Nous visons à réaliser des projets qui contribuent positivement au développement des communautés et à l’environnement dans lequel nous opérons.",
  "about.engagement.mission.title": "Missions",
  "about.engagement.objectives.paragraph1": "Augmenter l’accès au logement abordable : contribuer à la résolution de la crise du logement en fournissant des logements abordables pour les personnes à faibles revenus.",
  "about.engagement.objectives.paragraph2": "Améliorer la qualité et la durabilité des logements : construire des logements de haute qualité, durables et économes en énergie pour assurer le bien-être des résidents et réduire l'impact environnemental.",
  "about.engagement.objectives.title": "Objectifs",
  "about.engagement.paragraph1": "SOCABEG a ainsi participé au développement de nouvelles zones urbaines par la construction de plusieurs milliers de logements destinés à une large partie de la population sénégalaise disposant de revenus modestes.",
  "about.engagement.paragraph2": "Notre expertise, notre capacité industrielle et notre rigueur opérationnelle nous permettent de développer des projets de qualité, structurants et durables, répondant aux besoins d'un marché en pleine évolution.",
  "about.engagement.paragraph3": "En maîtrisant toute la chaîne de valeur du foncier jusqu'à la livraison clé en main, nous offrons des solutions immobilières accessibles et fiables. Notre performance repose sur des investissements continus dans l'innovation, l'industrialisation des procédés, et une flotte d'équipements de dernière génération, nous permettant de produire jusqu'à 100 logements en 6 mois.",
  "about.engagement.paragraph4": "Engagée aux côtés des territoires, SOCABEG favorise l'emploi local et mène des actions fortes de responsabilité sociale, notamment dans le sport communautaire et le soutien aux initiatives nationales. En effet, SOCABEG a pendant longtemps sponsoriser les championnats de quartiers (Navétanes) et les Lionnes, Equipe Nationale de Basket Féminin, Championne d'Afrique.",
  "about.engagement.paragraph5": "Nous remercions nos clients et nos partenaires pour la confiance qu'ils nous témoignent, ainsi que nos équipes pour le professionnalisme et la mobilisation dont elles font preuve chaque jour à travers les projets nous permettant de poursuivre notre mission : bâtir durablement, créer de la valeur et accompagner la transformation urbaine du Sénégal.",
  "about.engagement.quote": "DEPUIS 40 ANS, SOCABEG S'IMPOSE COMME UN ACTEUR MAJEUR DE LA CONSTRUCTION ET DE LA PROMOTION IMMOBILIÈRE AU SÉNÉGAL ET S'ENGAGE AUX CÔTÉS DES SÉNÉGALAIS POUR LEUR PERMETTRE DE RÉALISER LE RÊVE DE DEVENIR PROPRIÉTAIRE DE LEUR LOGEMENT",
  "about.engagement.subtitle": "NOTRE ENGAGEMENT",
  "about.engagement.title": "NOTRE ENGAGEMENT",
  "about.engagement.vision.paragraph1": "Être reconnue comme l’entreprise de référence dans le secteur du BTP, offrant des solutions innovantes et durables pour la construction d’infrastructures essentielles à Dakar et à l’international.",
  "about.engagement.vision.paragraph2": "Nous aspirons à développer des partenariats solides avec nos clients, à attirer et à développer les meilleurs talents, et à devenir un acteur majeur dans le développement de projets de grande envergure qui façonnent le futur de notre société.",
  "about.engagement.vision.title": "Vision",
  "about.foundations.title": "Nos fondements",
  "about.hero.subtitle": "Notre récit est l'empreinte d'une passion et d'une détermination depuis plus de 30 ans.",
  "about.hero.title": "Notre Histoire, \nnos principes, nos perspectives ...",
  "about.history.event1.description": "Construction et promotion immobilière.",
  "about.history.event1.title": "Création de SOCABEG SA",
  "about.history.event1.year": "Juin 1986",
  "about.history.event2.description": "Réalisation de 124 logements à Rufisque et bien d'autres réalisations à Dakar et environ.",
  "about.history.event2.title": "Premiers chantiers",
  "about.history.event2.year": "1988",
  "about.history.event3.description": "Diversification et développement de projets immobiliers et d'infrastructures entre 1989 et 2000.",
  "about.history.event3.title": "Développement de projets variés",
  "about.history.event3.year": "1989 - 2000",
  "about.history.event4.description": "Expansion de nos activités vers la recherche minière.",
  "about.history.event4.title": "Création de SOCABEG Mining",
  "about.history.event4.year": "2015",
  "about.history.event5.description": "Construction et mise en service du siège social.",
  "about.history.event5.title": "Inauguration du siège",
  "about.history.event5.year": "2017",
  "about.history.event6.description": "Lancement du programme Balena, 1er projet haut standing.",
  "about.history.event6.title": "Création de la filiale Keur Invest",
  "about.history.event6.year": "2018",
  "about.history.event7.description": "Construction de plus de 500 logements et réalisation de projets de viabilisation.",
  "about.history.event7.title": "Projets immobiliers d'envergure",
  "about.history.event7.year": "2019 à aujourd'hui",
  "about.history.event8.description": "Acquisition d'une nouvelle centrale à béton aux Almadies, renforçant notre capacité de production.",
  "about.history.event8.title": "Nouvelle centrale à béton - Almadies",
  "about.history.event8.year": "2025",
  "about.history.events.balena.description": "[TRADUCTION MANQUANTE: Start of the high-end real estate project Le Clos des Balena]",
  "about.history.events.balena.title": "[TRADUCTION MANQUANTE: Le Clos des Balena]",
  "about.history.events.creation.description": "[TRADUCTION MANQUANTE: Construction and Real Estate Development]",
  "about.history.events.creation.title": "[TRADUCTION MANQUANTE: Creation of SOCABEG SA]",
  "about.history.events.expansion.description": "[TRADUCTION MANQUANTE: Expansion of activities in public works and institutional buildings]",
  "about.history.events.expansion.title": "[TRADUCTION MANQUANTE: Activity expansion]",
  "about.history.events.keurinvest.description": "[TRADUCTION MANQUANTE: Creation of the KEURINVEST subsidiary for real estate development]",
  "about.history.events.keurinvest.title": "[TRADUCTION MANQUANTE: KEURINVEST]",
  "about.history.events.materiels.description": "[TRADUCTION MANQUANTE: Acquisition of new heavy equipment and specialization in construction]",
  "about.history.events.materiels.title": "[TRADUCTION MANQUANTE: Equipment acquisition]",
  "about.history.events.mining.description": "[TRADUCTION MANQUANTE: Creation of the SOCABEG Mining branch for the mining sector]",
  "about.history.events.mining.title": "[TRADUCTION MANQUANTE: SOCABEG Mining]",
  "about.history.events.premiers.description": "[TRADUCTION MANQUANTE: Completion of first housing sites in Senegal]",
  "about.history.events.premiers.title": "[TRADUCTION MANQUANTE: First sites]",
  "about.history.events.residentiels.description": "[TRADUCTION MANQUANTE: Launch of several residential projects in Dakar and its suburbs]",
  "about.history.events.residentiels.title": "[TRADUCTION MANQUANTE: Residential projects]",
  "about.history.highlight": "NOTRE PARCOURS DEPUIS 1986",
  "about.history.timeline.1980": "[TRADUCTION MANQUANTE: 1980s - 1990s]",
  "about.history.timeline.1983": "[TRADUCTION MANQUANTE: 1986]",
  "about.history.timeline.2000s": "[TRADUCTION MANQUANTE: 2000s]",
  "about.history.timeline.2010": "[TRADUCTION MANQUANTE: 2010]",
  "about.history.timeline.2015": "[TRADUCTION MANQUANTE: 2015]",
  "about.history.timeline.2018": "[TRADUCTION MANQUANTE: 2018]",
  "about.history.timeline.2020": "[TRADUCTION MANQUANTE: 2020]",
  "about.history.title": "HISTORIQUE",
  "about.organization.description1": "Société anonyme au capital de 1 milliard de francs CFA créée en 1986, SOCABEG a pour volonté d’améliorer le cadre de vie des Sénégalais en leur proposant des programmes immobiliers innovants de qualité à un prix attractif et adapté. Son ambition a toujours été d’allier construction de qualité et coût accessible.",
  "about.organization.description2": "L’organisation SOCABEG s’articule autour de plusieurs pôles de compétences opérant en parfaite synergie. Cette organisation en différentes directions et services permet à l’entreprise d’atteindre le niveau d’expertise nécessaire pour apporter une réponse appropriée aux attentes de chacun de ses clients.",
  "about.organization.structure.paragraph1": "Sous la responsabilité de la Direction Générale, secondée par un comité de Direction et s’appuyant sur un Conseil d’administration composé de professionnels dotés de longues et riches expériences, afin de :",
  "about.organization.structure.point1": "générer des échanges fructueux et mieux croiser les expériences et expertises,",
  "about.organization.structure.point2": "être au plus près des attentes de nos clients, et garantir la qualité et la performance de nos projets.",
  "about.organization.tagline": "Fiers bâtisseurs d’aujourd’hui, créateurs de l’héritage de demain",
  "about.organization.title": "ORGANISATION",
  "about.values.caring.description": "Nous prenons soin de nos clients, de nos collaborateurs et des communautés dans lesquelles nous opérons, en agissant avec respect, empathie et responsabilité.",
  "about.values.caring.title": "BIENVEILLANCE",
  "about.values.description1": "Elles nous guident dans chaque décision, chaque projet et chaque interaction. Elles reflètent notre culture d’entreprise et influencent la manière dont nous interagissons avec nos collaborateurs.",
  "about.values.description2": "Ces valeurs fondamentales sont le socle sur lequel repose notre engagement envers l'excellence et l'intégrité. Nous croyons fermement que la transparence et la communication ouverte renforcent la confiance et favorisent un environnement de travail harmonieux. En cultivant un esprit d'innovation et de collaboration, nous visons à inspirer et à motiver chaque membre de notre équipe à donner le meilleur de lui-même. Ainsi, ensemble, nous pouvons surmonter les défis, célébrer les succès et continuer à croître tout en restant fidèles à nos principes.",
  "about.values.engagement.description": "Nous nous engageons pleinement dans chaque projet, avec passion et détermination, pour dépasser les attentes de nos clients.",
  "about.values.engagement.title": "ENGAGEMENT",
  "about.values.mainTitle": "NOS VALEURS SONT AU CŒUR DE TOUT CE QUE NOUS FAISONS",
  "about.values.quality.description": "Nous visons l’excellence dans tout ce que nous faisons, en respectant les normes les plus élevées et en recherchant l’amélioration continue.",
  "about.values.quality.title": "QUALITÉ",
  "about.values.sharing.description": "Nous valorisons le partage des connaissances, des expériences et des ressources pour créer une culture collaborative qui bénéficie à tous nos projets et partenaires.",
  "about.values.sharing.title": "PARTAGE",
  "about.values.solution.description": "Nous sommes orientés vers les solutions, cherchant toujours à résoudre les défis avec créativité et efficacité pour garantir la réussite de chaque projet.",
  "about.values.solution.title": "SOLUTION",
  "about.values.title": "NOS VALEURS",

  // =========================
  // REALESTATE
  // =========================
  "realEstate.areaName": "Localité",
  "realEstate.backToList": "Retour à la liste",
  "realEstate.budgetPlaceholder": "Budget en FCFA",
  "realEstate.hero.subtitle": "Découvrez une vaste sélection de biens adaptés à vos futures acquisitions.",
  "realEstate.hero.title": "Nous construisons des espaces de vie qui perdurent dans le temps ...",
  "realEstate.location": "Localisation",
  "realEstate.locations.almadies": "Almadies",
  "realEstate.locations.almadies2": "Almadies 2",
  "realEstate.locations.hlm5": "Hlm 5",
  "realEstate.locations.ndiakhirate": "Ndiakhirate",
  "realEstate.locations.tivaouanePeulh": "Tivaouane Peulh",
  "realEstate.maxBudget": "Budget maximum",
  "realEstate.programsTitle": "Nos programmes immobiliers",
  "realEstate.propertyType": "Type de propriété",
  "realEstate.propertyTypes.apartment": "Appartement",
  "realEstate.propertyTypes.commercial": "Boutiques",
  "realEstate.propertyTypes.house": "Villa",
  "realEstate.propertyTypes.housing": "Logements",
  "realEstate.propertyTypes.land": "Terrains",
  "realEstate.propertyTypes.socialHousing": "Logements",
  "realEstate.searchButton": "Rechercher",
  "realEstate.searchDescription": "Maisons, locaux commerciaux, terrains ou logements sociaux… Trouvez le programme qui vous correspond le mieux…",
  "realEstate.searchError": "Veuillez remplir au moins un champ pour effectuer une recherche.",
  "realEstate.searchTitle": "RECHERCHER UN BIEN",
  "realEstate.selectLocation": "Choisir une localité",
  "realEstate.selectPropertyType": "Choisir un type de propriété",
  "realEstate.subtitle": "Votre partenaire de confiance pour des projets immobiliers innovants et durables",
  "realEstate.viewAllProperties": "Voir tous nos biens",

  // =========================
  // CONSTRUCTION
  // =========================
  "construction.amenagement.cta": "Demander un devis",
  "construction.amenagement.imageAlt": "Espace urbain aménagé par SOCABEG",
  "construction.amenagement.paragraph1": "La SOCABEG dispose d'une division dédiée à l'aménagement d'espaces urbains ou ruraux.",
  "construction.amenagement.paragraph2": "Depuis sa fondation, SOCABEG a démontré son expertise dans l'aménagement de quartiers entiers et d'espaces publics.",
  "construction.amenagement.paragraph3": "L'entreprise s'engage dans des initiatives durables, intégrant des technologies vertes et des matériaux respectueux de l'environnement.",
  "construction.amenagement.paragraph4": "Notre équipe propose des solutions sur mesure qui allient esthétique et praticité pour le développement économique et social.",
  "construction.amenagement.paragraph5": "SOCABEG aspire à être un modèle de responsabilité sociale et environnementale au Sénégal.",
  "construction.amenagement.subtitle": "Entreprise à taille humaine, nous sommes à votre écoute pour concevoir, collaborer et construire ensemble votre futur « chez vous ».",
  "construction.amenagement.title": "Aménagement",
  "construction.building.cta": "Demander un devis",
  "construction.building.imageAlt": "Chantier de construction de bâtiment",
  "construction.building.paragraph1": "Reconnue comme leader dans la réalisation de logements au Sénégal, SOCABEG s'est forgée une solide réputation grâce à son expertise, son dévouement et sa maîtrise du bâtiment.",
  "construction.building.paragraph2": "De la définition du projet à la livraison, en passant par sa conception et le suivi de sa construction, nos techniciens s'assurent du bon déroulement des opérations en toute sécurité, avant, pendant et après la livraison.",
  "construction.building.paragraph3": "Nous construisons des édifices avec notre savoir-faire et une vision claire : bureaux, entrepôts, boutiques, bâtiments commerciaux et industriels, complexes sportifs, etc.",
  "construction.building.paragraph4": "Avec une approche centrée sur la qualité et l'innovation, SOCABEG s'engage à répondre aux besoins variés de ses clients tout en respectant les normes environnementales et sociétales.",
  "construction.building.subtitle": "Des solutions complètes et un accompagnement sur mesure de A à Z pour la réussite de vos projets.",
  "construction.building.title": "Bâtiments",
  "construction.civilEngineering.cta": "Demander un devis",
  "construction.civilEngineering.imageAlt": "Chantier de génie civil",
  "construction.civilEngineering.paragraph1": "SOCABEG comprend une division dédiée au génie civil. Nos ingénieurs mettent en œuvre des solutions pour tout type de projets : routes, ponts, barrages, canaux, tunnels, etc.",
  "construction.civilEngineering.paragraph2": "Grâce à nos investissements dans les nouvelles technologies et équipements, nous avons pu automatiser le processus de construction et réaliser d'importants gains de productivité.",
  "construction.civilEngineering.paragraph3": "Nos prestations incluent : études techniques, conception, réalisation et rénovation d'infrastructures.",
  "construction.civilEngineering.paragraph4": "Nous garantissons des résultats de haute qualité avec une attention particulière à la durabilité et à la sécurité de nos ouvrages.",
  "construction.civilEngineering.paragraph5": "Nous collaborons avec nos partenaires pour des constructions qui répondent aux besoins des communautés.",
  "construction.civilEngineering.subtitle": "Plus de 40 ans d’expérience à votre service, avec une assistance conforme aux exigences du secteur du BTP",
  "construction.civilEngineering.title": "Génie civil",
  "construction.hero.subtitle": "Expertise en bâtiment, génie civil et aménagement de territoire",
  "construction.hero.title": "Au cœur de la construction pour \nvous offrir un meilleur cadre de vie",

  // =========================
  // MINING
  // =========================
  "mining.activity.geographic.content": "Le projet « NDINDY » est localisé dans une position stratégique :",
  "mining.activity.geographic.point1": "Entouré par la petite mine de Baobab Mining et les permis de recherche d’AIG et des ICS.",
  "mining.activity.geographic.point2": "À moins d’une dizaine de kilomètres de la petite mine de Gadde Bissik.",
  "mining.activity.geographic.point3": "Proximité des infrastructures portuaires et ferroviaires pour l'exportation.",
  "mining.activity.geographic.title": "Atout géographique",
  "mining.activity.objective": "Notre objectif :",
  "mining.activity.objectiveText": "Développer des partenariats pour offrir des avantages durables à long terme, fondés sur un modèle de responsabilité partagée et de responsabilisation, afin de garantir que ces avantages perdurent au-delà de la durée de vie de la mine.",
  "mining.activity.steps.exploration.text": "Nous menons des activités d’exploration pour identifier et évaluer les gisements minéraux potentiels en utilisant des techniques géologiques et géophysiques.",
  "mining.activity.steps.exploration.title": "Exploration des gisements",
  "mining.activity.steps.mining.text": "Nous procédons à l’extraction des minéraux et des minerais de manière efficace et responsable, tout en maximisant les rendements économiques.",
  "mining.activity.steps.mining.title": "Exploitation minière",
  "mining.activity.steps.processing.text": "Nous mettons en œuvre des procédés de traitement pour séparer les minéraux de valeur du minerai brut et produire des concentrés ou des produits finis commercialisables.",
  "mining.activity.steps.processing.title": "Traitement du minerai",
  "mining.activity.subtitle": "L’ACTIVITÉ EN BREF…",
  "mining.activity.title": "Notre activité minière",
  "mining.advantages.title": "Nos atouts",
  "mining.contact.address": "Fann Hock en face de la Cour Suprême",
  "mining.contact.email": "mining@socabeg.sn",
  "mining.contact.title": "CONTACTEZ-NOUS",
  "mining.contact.website": "www.socabeg.com",
  "mining.esg.point1": "Étude d'impact validée (juin 2023), approbation finale attendue T4 2025",
  "mining.esg.point2": "Investissements sociaux : écoles, santé, infrastructures, emploi local",
  "mining.esg.title": "ENGAGEMENT ESG",
  "mining.hero.subtitle": "Expertise et solutions durables pour l'industrie minière",
  "mining.hero.title": "L'innovation minière : Des actions percutantes transformant le secteur pour un avenir plus durable...",
  "mining.market.point1": "Forte demande mondiale (agriculture, sécurité alimentaire)",
  "mining.market.point2": "Clients cibles : producteurs d'engrais, négociants internationaux",
  "mining.market.title": "MARCHÉ",
  "mining.phosphates.location.description": "Projet situé au Sénégal (Région de Thiès), à 170 km du port de Dakar.",
  "mining.phosphates.location.title": "LOCALISATION",
  "mining.phosphates.production.point1": "Mine à ciel ouvert de 1,5 Mt de minerai/an → 600 000 t de concentré de phosphate (32 % P₂O₅)",
  "mining.phosphates.production.point2": "Procédé : criblage à sec (CAPEX/OPEX réduit)",
  "mining.phosphates.production.point3": "Démarrage prévu : 2027",
  "mining.phosphates.production.point4": "Phases futures : extension minière (256 km²), usine d'engrais.",
  "mining.phosphates.production.title": "PRODUCTION",
  "mining.phosphates.resources.point1": "Licence de Petite mine (5 km², 2024) – extension à 256 km² en cours",
  "mining.phosphates.resources.point2": "109 Mt de ressources inférées, dont 37,3 Mt à 16,7 % P₂O₅ (JORC 2012, seuil 10 %)",
  "mining.phosphates.resources.point3": "Durée de vie : 10 ans (Phase 1), extensible à 20+ ans.",
  "mining.phosphates.resources.title": "RESSOURCES",
  "mining.phosphates.subtitle": "UNE OPPORTUNITÉ MINIÈRE STRATÉGIQUE AU SÉNÉGAL",
  "mining.phosphates.title": "NOTRE PROJET DES PHOSPHATES DE NIAKHAL",
  "mining.presentation.about.paragraph1": "SOCABEG Mining est une société sénégalaise d’exploration minière, filiale du groupe SOCABEG. Elle est spécialisée dans l’acquisition, l’exploration et la mise en valeur de propriétés minières au Sénégal.",
  "mining.presentation.about.paragraph2": "Le projet est situé au Sénégal dans la région de Diourbel, qui abrite d’importantes ressources de phosphate et continue d’attirer de grandes sociétés minières, dont la société Baobab Mining du groupe Avenira, déjà en production via sa petite mine de Gadde Bissik.",
  "mining.presentation.blue.paragraph1": "SOCABEG Mining détient à ce jour 100 % des actions du projet de phosphate de Ndindy. Le permis de recherche de phosphate de Ndindy est situé à 170 km de Dakar et à 27 km de la ville de Diourbel.",
  "mining.presentation.blue.paragraph2": "Le périmètre de recherche de phosphate a une superficie de 871 km² et est limité au nord et à l’ouest par le permis de recherche de Baobab Mining, au nord-est par le permis de Kébémère de la société Africa Investment Group (AIG) et au sud par le permis de Gossas des ICS.",
  "mining.presentation.blue.paragraph3": "En mars et avril 2018, SOCABEG Mining a terminé un premier programme d’exploration de forage RC de plus de 1 400 mètres linéaires sur le permis de Ndindy.",
  "mining.presentation.subtitle": "Une exploitation minière durable créatrice de valeur",
  "mining.presentation.title": "Présentation de SOCABEG Mining",
  "mining.whyInvest.point1": "Ressources évolutives à haute teneur",
  "mining.whyInvest.point2": "Rentabilité élevée & retour rapide",
  "mining.whyInvest.point3": "Environnement réglementaire stable",
  "mining.whyInvest.point4": "Engagement ESG solide",
  "mining.whyInvest.title": "POURQUOI INVESTIR ?",

  // =========================
  // CAREERS
  // =========================
  "careers.applyNow": "Postuler maintenant",
  "careers.backToJobs": "Retour aux offres",
  "careers.job1.company": "SOCABEG",
  "careers.job1.description": "Nous recherchons un chef de chantier expérimenté pour superviser nos projets de construction. Vous serez responsable de la coordination des équipes et du bon déroulement des travaux.",
  "careers.job1.location": "Dakar",
  "careers.job1.requirements": [
    "Diplôme en génie civil ou équivalent",
    "Minimum 5 ans d'expérience en tant que chef de chantier",
    "Excellentes compétences en gestion d'équipe",
    "Maîtrise des normes de sécurité sur chantier"
  ],
  "careers.job1.responsibilities": [
    "Superviser l'ensemble des travaux sur le chantier",
    "Coordonner les différents corps de métier",
    "Assurer le respect des délais et des budgets",
    "Veiller à la qualité des travaux réalisés"
  ],
  "careers.job1.title": "Chef de chantier",
  "careers.job1.type": "CDI",
  "careers.job10.company": "SOCABEG",
  "careers.job10.description": "Nous recherchons un plombier de chantier pour réaliser les installations sanitaires et de plomberie sur nos projets de construction. Vous serez responsable de la mise en place des réseaux d'eau et d'évacuation.",
  "careers.job10.location": "Dakar",
  "careers.job10.requirements": [
    "CAP ou BEP en plomberie",
    "Expérience de 3 ans minimum en plomberie de chantier",
    "Connaissance des techniques de soudure et d'assemblage",
    "Maîtrise des normes sanitaires"
  ],
  "careers.job10.responsibilities": [
    "Installer les réseaux d'alimentation en eau",
    "Mettre en place les systèmes d'évacuation",
    "Poser les appareils sanitaires",
    "Effectuer les tests d'étanchéité"
  ],
  "careers.job10.title": "Plombier de chantier",
  "careers.job10.type": "CDI",
  "careers.job11.company": "SOCABEG",
  "careers.job11.description": "Nous recherchons un comptable général pour assurer la tenue et la fiabilité des comptes du groupe SOCABEG.",
  "careers.job11.location": "Dakar",
  "careers.job11.requirements": [
    "BAC+3 en comptabilité, finance ou équivalent",
    "Expérience de 3 ans minimum en comptabilité générale",
    "Maîtrise des normes comptables OHADA",
    "Excellente maîtrise d’Excel et d’un logiciel comptable"
  ],
  "careers.job11.responsibilities": [
    "Assurer la saisie et le contrôle des opérations comptables",
    "Préparer les déclarations fiscales et sociales",
    "Participer à l’élaboration des états financiers",
    "Garantir la conformité des écritures avec les procédures internes"
  ],
  "careers.job11.title": "Comptable général",
  "careers.job11.type": "CDI",
  "careers.job12.company": "SOCABEG",
  "careers.job12.description": "Vous gérez le cycle fournisseurs : traitement des factures, rapprochements et suivi des paiements.",
  "careers.job12.location": "Dakar",
  "careers.job12.requirements": [
    "BAC+2/3 en comptabilité",
    "Expérience sur un poste similaire souhaitée",
    "Rigueur, sens du détail et respect des délais",
    "Bonne maîtrise d’Excel et des outils bureautiques"
  ],
  "careers.job12.responsibilities": [
    "Saisir et contrôler les factures fournisseurs",
    "Effectuer les rapprochements avec les bons de commande et de livraison",
    "Préparer les campagnes de règlements",
    "Gérer les relances et litiges fournisseurs"
  ],
  "careers.job12.title": "Comptable fournisseurs",
  "careers.job12.type": "CDI",
  "careers.job13.company": "SOCABEG",
  "careers.job13.description": "Stage d’assistant comptable pour appuyer l’équipe dans les travaux quotidiens de comptabilité.",
  "careers.job13.location": "Dakar",
  "careers.job13.requirements": [
    "Étudiant(e) en comptabilité, finance ou gestion",
    "Bonne maîtrise d’Excel",
    "Envie d’apprendre et de travailler en équipe",
    "Sens de l’organisation et confidentialité"
  ],
  "careers.job13.responsibilities": [
    "Participer à la saisie des pièces comptables",
    "Aider aux rapprochements bancaires",
    "Classer et archiver les documents comptables",
    "Contribuer aux travaux de clôture mensuelle"
  ],
  "careers.job13.title": "Assistant comptable (Stage)",
  "careers.job13.type": "Stage",
  "careers.job14.company": "SOCABEG",
  "careers.job14.description": "Nous recherchons un contrôleur de gestion pour piloter la performance financière de nos projets et filiales.",
  "careers.job14.location": "Dakar",
  "careers.job14.requirements": [
    "BAC+4/5 en contrôle de gestion, finance ou école de commerce",
    "Expérience de 3 ans minimum en contrôle de gestion",
    "Excellente maîtrise d’Excel et des outils de reporting",
    "Capacité d’analyse et esprit de synthèse"
  ],
  "careers.job14.responsibilities": [
    "Élaborer et suivre les budgets",
    "Analyser les écarts entre prévisionnel et réalisé",
    "Produire des tableaux de bord et indicateurs de performance",
    "Accompagner les directions opérationnelles dans la prise de décision"
  ],
  "careers.job14.title": "Contrôleur de gestion",
  "careers.job14.type": "CDI",
  "careers.job15.company": "SOCABEG",
  "careers.job15.description": "Vous réalisez des analyses financières et des études de rentabilité pour les projets du groupe.",
  "careers.job15.location": "Dakar",
  "careers.job15.requirements": [
    "BAC+4/5 en finance, audit ou école de commerce",
    "Excellentes capacités d’analyse financière",
    "Maîtrise d’Excel et des outils de modélisation",
    "Bonne connaissance des états financiers"
  ],
  "careers.job15.responsibilities": [
    "Analyser la rentabilité des projets et investissements",
    "Préparer des notes et rapports financiers pour la direction",
    "Participer aux prévisions de trésorerie et plans de financement",
    "Contribuer à l’amélioration des outils d’analyse"
  ],
  "careers.job15.title": "Analyste financier",
  "careers.job15.type": "CDI",
  "careers.job16.company": "SOCABEG",
  "careers.job16.description": "Vous gérez la trésorerie du groupe, le suivi des flux financiers et la relation avec les banques.",
  "careers.job16.location": "Dakar",
  "careers.job16.requirements": [
    "BAC+3/5 en finance ou comptabilité",
    "Expérience en trésorerie ou gestion de caisse",
    "Maîtrise d’Excel et des outils bancaires en ligne",
    "Rigueur, fiabilité et sens de la confidentialité"
  ],
  "careers.job16.responsibilities": [
    "Suivre quotidiennement les positions de trésorerie",
    "Préparer les prévisions de trésorerie",
    "Optimiser les flux de paiements et encaissements",
    "Assurer le suivi des relations avec les partenaires bancaires"
  ],
  "careers.job16.title": "Trésorier(ère)",
  "careers.job16.type": "CDI",
  "careers.job17.company": "SOCABEG",
  "careers.job17.description": "Vous êtes en charge du suivi des encaissements clients et des actions de recouvrement.",
  "careers.job17.location": "Dakar",
  "careers.job17.requirements": [
    "BAC+2/3 en comptabilité, finance ou gestion commerciale",
    "Bonne aisance relationnelle et capacité de négociation",
    "Organisation et persévérance",
    "Maîtrise des outils bureautiques"
  ],
  "careers.job17.responsibilities": [
    "Suivre les encours clients et les retards de paiement",
    "Relancer les clients par téléphone et par écrit",
    "Proposer des plans de règlement lorsque nécessaire",
    "Mettre à jour les dossiers clients et reporting de recouvrement"
  ],
  "careers.job17.title": "Chargé(e) de recouvrement",
  "careers.job17.type": "CDD",
  "careers.job18.company": "SOCABEG",
  "careers.job18.description": "Nous recherchons un chef du personnel pour gérer l'ensemble des ressources humaines de l'entreprise. Vous serez responsable du recrutement, de la formation et de la gestion administrative du personnel.",
  "careers.job18.location": "Dakar",
  "careers.job18.requirements": [
    "Formation supérieure en ressources humaines ou gestion",
    "Expérience de 5 ans minimum dans un poste similaire",
    "Connaissance du droit du travail sénégalais",
    "Compétences en gestion des conflits et leadership"
  ],
  "careers.job18.responsibilities": [
    "Gérer le recrutement et l'intégration des nouveaux employés",
    "Assurer la gestion administrative du personnel",
    "Élaborer et mettre en œuvre les plans de formation",
    "Veiller au respect du droit du travail et des conventions collectives"
  ],
  "careers.job18.title": "Responsable achats",
  "careers.job18.type": "CDI",
  "careers.job19.company": "SOCABEG",
  "careers.job19.description": "Nous recherchons un comptable client pour gérer la facturation et le suivi des paiements. Vous serez responsable de la gestion des comptes clients et du recouvrement.",
  "careers.job19.location": "Dakar",
  "careers.job19.requirements": [
    "Formation en comptabilité ou gestion",
    "Expérience de 3 ans minimum dans un poste similaire",
    "Maîtrise des logiciels de comptabilité",
    "Rigueur et sens de l'organisation"
  ],
  "careers.job19.responsibilities": [
    "Établir les factures clients",
    "Assurer le suivi des paiements",
    "Gérer les relances et le recouvrement",
    "Préparer les rapports financiers clients"
  ],
  "careers.job19.title": "Comptable client",
  "careers.job19.type": "CDI",
  "careers.job2.company": "SOCABEG",
  "careers.job2.description": "Nous recherchons un conducteur de travaux adjoint pour assister notre équipe dans la gestion des chantiers. Vous participerez à la planification et au suivi des projets de construction.",
  "careers.job2.location": "Dakar",
  "careers.job2.requirements": [
    "Formation en génie civil ou bâtiment",
    "Expérience de 2 à 3 ans sur des postes similaires",
    "Bonnes connaissances techniques en construction",
    "Capacité à lire et interpréter des plans"
  ],
  "careers.job2.responsibilities": [
    "Assister le conducteur de travaux principal",
    "Suivre l'avancement des travaux",
    "Coordonner les interventions des sous-traitants",
    "Participer aux réunions de chantier"
  ],
  "careers.job2.title": "Conducteur de travaux adjoint",
  "careers.job2.type": "CDI",
  "careers.job20.company": "SOCABEG",
  "careers.job20.description": "Nous recherchons un comptable fournisseur pour gérer les factures et les paiements aux fournisseurs. Vous serez responsable du traitement des factures et du suivi des échéances.",
  "careers.job20.location": "Dakar",
  "careers.job20.requirements": [
    "Formation en comptabilité ou gestion",
    "Expérience de 3 ans minimum dans un poste similaire",
    "Maîtrise des logiciels de comptabilité",
    "Rigueur et sens de l'organisation"
  ],
  "careers.job20.responsibilities": [
    "Traiter les factures fournisseurs",
    "Préparer les paiements",
    "Assurer le suivi des échéances",
    "Gérer les litiges fournisseurs"
  ],
  "careers.job20.title": "Comptable fournisseur",
  "careers.job20.type": "CDI",
  "careers.job3.company": "SOCABEG",
  "careers.job3.description": "Nous recherchons un topographe/géomètre pour réaliser les relevés et implantations sur nos différents chantiers. Vous serez chargé de garantir la précision des mesures et des plans.",
  "careers.job3.location": "Thiès",
  "careers.job3.requirements": [
    "Diplôme en topographie ou géomètre-expert",
    "Expérience de 3 ans minimum dans le domaine",
    "Maîtrise des instruments de mesure et logiciels spécialisés",
    "Rigueur et précision dans le travail"
  ],
  "careers.job3.responsibilities": [
    "Réaliser les relevés topographiques",
    "Effectuer les implantations sur le terrain",
    "Établir les plans et documents techniques",
    "Assurer le suivi des modifications du terrain"
  ],
  "careers.job3.title": "Topographe / Géomètre",
  "careers.job3.type": "CDI",
  "careers.job4.company": "SOCABEG",
  "careers.job4.description": "Nous recherchons un dessinateur projeteur pour réaliser les plans techniques de nos projets de construction. Vous travaillerez en étroite collaboration avec nos ingénieurs et architectes.",
  "careers.job4.location": "Dakar",
  "careers.job4.requirements": [
    "Formation en dessin technique ou génie civil",
    "Maîtrise des logiciels de CAO/DAO (AutoCAD, Revit)",
    "Expérience de 2 ans minimum dans un poste similaire",
    "Bonne connaissance des normes de construction"
  ],
  "careers.job4.responsibilities": [
    "Réaliser les plans d'exécution",
    "Participer aux études techniques",
    "Effectuer les modifications demandées par les clients",
    "Assurer la cohérence des documents techniques"
  ],
  "careers.job4.title": "Dessinateur projeteur",
  "careers.job4.type": "CDD",
  "careers.job5.company": "SOCABEG",
  "careers.job5.description": "Nous recherchons un technicien en bâtiment pour assurer le suivi technique de nos chantiers. Vous serez chargé de veiller à la qualité des travaux et au respect des normes.",
  "careers.job5.location": "Dakar",
  "careers.job5.requirements": [
    "BTS ou DUT en génie civil ou bâtiment",
    "Expérience de 2 ans minimum dans le secteur",
    "Connaissance des techniques de construction",
    "Capacité à lire et interpréter des plans techniques"
  ],
  "careers.job5.responsibilities": [
    "Contrôler la qualité des travaux",
    "Vérifier la conformité aux plans et aux normes",
    "Rédiger des rapports techniques",
    "Participer aux réunions de chantier"
  ],
  "careers.job5.title": "Technicien en bâtiment",
  "careers.job5.type": "CDD",
  "careers.job6.company": "SOCABEG",
  "careers.job6.description": "Nous recherchons un technicien en génie civil pour participer à nos projets d'infrastructure. Vous serez impliqué dans la réalisation et le suivi des travaux de génie civil.",
  "careers.job6.location": "Saint-Louis",
  "careers.job6.requirements": [
    "DUT ou BTS en génie civil",
    "Expérience de 2 ans minimum dans le domaine",
    "Connaissance des techniques de construction",
    "Capacité à travailler en équipe"
  ],
  "careers.job6.responsibilities": [
    "Participer aux études techniques",
    "Suivre la réalisation des travaux",
    "Contrôler la qualité des ouvrages",
    "Rédiger des rapports de suivi"
  ],
  "careers.job6.title": "Technicien en génie civil",
  "careers.job6.type": "CDD",
  "careers.job7.company": "SOCABEG",
  "careers.job7.description": "Nous recherchons un maçon qualifié pour rejoindre notre équipe de construction. Vous serez responsable de la réalisation des travaux de maçonnerie sur nos différents chantiers.",
  "careers.job7.location": "Dakar",
  "careers.job7.requirements": [
    "CAP ou BEP en maçonnerie",
    "Expérience de 2 ans minimum dans le métier",
    "Maîtrise des techniques de maçonnerie",
    "Respect des normes de sécurité"
  ],
  "careers.job7.responsibilities": [
    "Réaliser des travaux de maçonnerie",
    "Construire des murs, cloisons et fondations",
    "Appliquer les enduits et finitions",
    "Respecter les plans et les consignes"
  ],
  "careers.job7.title": "Maçon",
  "careers.job7.type": "Stage",
  "careers.job8.company": "SOCABEG",
  "careers.job8.description": "Nous recherchons un coffreur/ferrailleur pour nos chantiers de construction. Vous serez chargé de réaliser les coffrages et la mise en place des armatures métalliques.",
  "careers.job8.location": "Dakar",
  "careers.job8.requirements": [
    "CAP ou BEP en construction",
    "Expérience de 2 ans minimum en coffrage et ferraillage",
    "Connaissance des techniques de coffrage",
    "Capacité à lire des plans de ferraillage"
  ],
  "careers.job8.responsibilities": [
    "Réaliser les coffrages selon les plans",
    "Mettre en place les armatures métalliques",
    "Assurer la qualité des ouvrages",
    "Respecter les normes de sécurité"
  ],
  "careers.job8.title": "Coffreur / Ferrailleur",
  "careers.job8.type": "Stage",
  "careers.job9.company": "SOCABEG",
  "careers.job9.description": "Nous recherchons un électricien de chantier pour réaliser les installations électriques sur nos projets de construction. Vous serez responsable de la mise en place et de la maintenance des installations électriques.",
  "careers.job9.location": "Thiès",
  "careers.job9.requirements": [
    "CAP ou BEP en électricité",
    "Habilitation électrique à jour",
    "Expérience de 3 ans minimum en électricité de chantier",
    "Connaissance des normes électriques"
  ],
  "careers.job9.responsibilities": [
    "Réaliser les installations électriques",
    "Effectuer les raccordements et branchements",
    "Assurer la maintenance des équipements",
    "Respecter les normes de sécurité"
  ],
  "careers.job9.title": "Électricien de chantier",
  "careers.job9.type": "Stage",
  "careers.jobDetails": "Description du poste",
  "careers.jobListings.title": "Offres d'emploi",
  "careers.missions": "Missions",
  "careers.noResults": "Aucune offre d'emploi ne correspond à votre recherche.",
  "careers.profile": "Profil recherché",
  "careers.results": "résultats",
  "careers.search.allTypes": "Tous les types",
  "careers.search.button": "RECHERCHER DES OFFRES D'EMPLOI",
  "careers.search.internship": "Stage",
  "careers.search.jobTitle": "Titre d'emploi",
  "careers.search.location": "Localisation",
  "careers.search.permanent": "CDI",
  "careers.search.temporary": "CDD",
  "careers.subtitle": "Découvrez nos opportunités de carrière et contribuez à façonner l'avenir du Sénégal",
  "careers.title": "REJOIGNEZ-NOUS",
  "careers.viewDetails": "Voir détails",

  // =========================
  // PROJECTS
  // =========================
  "projects.almadies.address": "Les Terrasses des Almadies",
  "projects.almadies.naturePapier": "TF",
  "projects.almadies.statut": "Viabilisé",
  "projects.almadies.description": "Terrains viabilisés à vendre au cœur d'un quartier dynamique et recherché. Profitez d'une opportunité d'investissement exceptionnelle dans l'un des secteurs les plus prisés de Dakar. Ces terrains offrent un cadre idéal pour construire la maison de vos rêves ou pour réaliser un projet immobilier rentable. Ne manquez pas cette chance unique de vous établir dans un environnement en pleine croissance, bénéficiant de toutes les commodités à proximité.",
  "projects.almadies.features": [
    "Quartier prisé",
    "Viabilisation complète",
    "Titre foncier",
    "Proximité des commodités"
  ],
  "projects.almadies.programPlus": "Les atouts de l'offre",
  "projects.almadies.booking.deposit": "Vente au comptant",
  "projects.almadies.booking.balance": "",
  "projects.almadies.booking.fees": "",
  "projects.almadies.booking.financing": "Possibilité de financement bancaire",
  "projects.almadies.localisation": "Almadies",
  "projects.almadies.price": "800 000 FCFA / m²",
  "projects.almadies.title": "Parcelles viabilisées – Almadies",
  "projects.almadies.type": "Terrains – 250 m²",
  "projects.almadies2.address": "Almadies 2",
  "projects.almadies2.naturePapier": "TF",
  "projects.almadies2.statut": "Viabilisé",
  "projects.almadies2.description": "Terrains viabilisés à vendre au cœur d'un quartier dynamique et recherché. Profitez d'une opportunité d'investissement exceptionnelle dans l'un des secteurs les plus prisés de Dakar. Ces terrains offrent un cadre idéal pour construire la maison de vos rêves ou pour réaliser un projet immobilier rentable. Ne manquez pas cette chance unique de vous établir dans un environnement en pleine croissance, bénéficiant de toutes les commodités à proximité.",
  "projects.almadies2.floor": "R+1",
  "projects.almadies2.localisation": "Almadies 2",
  "projects.almadies2.price": "25 000 000 FCFA",
  "projects.almadies2.booking.deposit": "Vente au comptant",
  "projects.almadies2.booking.balance": "",
  "projects.almadies2.booking.fees": "",
  "projects.almadies2.booking.financing": "Possibilité de financement bancaire",
  "projects.almadies2.title": "Terrains viabilisés – Almadies 2",
  "projects.almadies2.type": "Terrains – 150 m²",
  "projects.balena.address": "Le Clos des Balena",
  "projects.balena.description": "Situé dans le quartier huppé des Almadies, ce programme immobilier d'exception allie luxe et durabilité. Les villas spacieuses de 500 m² offrent une vue imprenable sur l'océan, avec des finitions haut de gamme et des équipements modernes.",
  "projects.balena.features": [
    "Piscine privée",
    "Jardin",
    "02 cuisines (Africaine et américaine)",
    "Site accessible proche des commodités",
    "Architecture moderne",
    "Espaces généreux"
  ],
  "projects.balena.programPlus": "Le + du programme",
  "projects.balena.booking.fees": "",
  "projects.balena.booking.deposit": "Mode VEFA - Acompte de 30% à la réservation",
  "projects.balena.booking.balance": "Solde à libérer suivant l'état d'avancement des travaux",
  "projects.balena.booking.financing": "Possibilité de financement bancaire",
  "projects.balena.floor": "R+1",
  "projects.balena.localisation": "Almadies",
  "projects.balena.price": "NOUS CONSULTER",
  "projects.balena.reservationConditions": "Mode VEFA - Acompte de 30% à la réservation\nSolde à libérer suivant l'état d'avancement des travaux\nPossibilité de financement bancaire",
  "projects.balena.title": "Résidences Balena – Almadies",
  "projects.balena.type": "Villa R+1 – 500 m²",
  "projects.contactUs": "Nous contacter",
  "projects.description": "Logements, espaces commerciaux ou terrains viabilisés… Découvrez le programme qui vous correspond le mieux.",
  "projects.discoverMore": "Découvrir plus",
  "projects.highlight": "PROGRAMMES À LA UNE",
  "projects.hlm.address": "Centre Commercial DAROU SALAM",
  "projects.hlm.description": "Idéalement situés dans le quartier dynamique de HLM 5, ces 105 locaux commerciaux de 12 m² chacun représentent une opportunité d'investissement unique. Avec une forte affluence et une accessibilité optimale, ces espaces sont parfaits pour les commerçants et entrepreneurs.",
  "projects.hlm.features": [
    "Emplacement stratégique",
    "Accès facile",
    "Sécurité 24/7",
    "Toilettes",
    "Eau et électricité",
    "Vitrine sur rue"
  ],
  "projects.hlm.programPlus": "Le + du programme",
  "projects.hlm.booking.fees": "",
  "projects.hlm.booking.deposit": "Acompte de 30 % à la réservation",
  "projects.hlm.booking.balance": "Solde à la livraison des clés",
  "projects.hlm.booking.financing": "Possibilité de financement bancaire",
  "projects.hlm.floor": "RDC",
  "projects.hlm.localisation": "Hlm 5",
  "projects.hlm.price": "25 000 000 FCFA",
  "projects.hlm.title": "Boutiques – Centre Commercial HLM",
  "projects.hlm.type": "Boutiques – 12 m²",
  "projects.ndiakhirate.booking.fees": "Frais de dossier 250.000 FCFA",
  "projects.ndiakhirate.booking.deposit": "Mode VEFA - Acompte de 40 % à la réservation",
  "projects.ndiakhirate.booking.balance": "Solde à libérer suivant l'état d'avancement des travaux",
  "projects.ndiakhirate.booking.financing": "Possibilité de financement bancaire",
  "projects.ndiakhirate.floor": "R+1",
  "projects.ndiakhirate.localisation": "Ndiakhirate",
  "projects.ndiakhirate.price": "35 000 000 FCFA",
  "projects.ndiakhirate.reservationConditions": "Frais de dossier 250.000 FCFA\nMode VEFA - Acompte de 40 % à la réservation\nSolde à libérer suivant l'état d'avancement des travaux\nPossibilité de financement bancaire",
  "projects.ndiakhirate.title": "Logements",
  "projects.ndiakhirate.type": "Villa – 150 m²",
  "projects.ndiakhirate.typeF3": "type F3",
  "projects.ndiakhirate.typeF4": "type F4",
  "projects.ndiakhirate.typeR1": "R+1 type F4",
  "projects.ndiakhirate.titleF3": "Logements type F3 – Ndiakhirate",
  "projects.ndiakhirate.titleF4": "Logements type F4 – Ndiakhirate",
  "projects.ndiakhirate.titleR1": "Logements R+1 type F4 – Ndiakhirate",
  "projects.ndiakhirate.description": "Ce projet de logements emblématique comprend des unités résidentielles, des espaces verts et des commodités modernes, mettant l'accent sur la durabilité et le bien-être. Les maisons offrent une belle luminosité, tandis que les espaces communs encouragent un mode de vie actif, créant un havre de paix urbain où modernité et tranquillité s'harmonisent.",
  "projects.ndiakhirate.address": "Résidences de Ndiakhirate",
  "projects.ndiakhirate.features": [
    "Maisons individuelles",
    "Espaces verts",
    "Cadre familial",
    "Accès facilité"
  ],
  "projects.parcelsTitle": "Parcelles viabilisées",
  "projects.sirena.address": "Résidences Sirena",
  "projects.sirena.description": "Le programme Sirena offre des appartements modernes et fonctionnels ainsi que des commerces de proximité. Un cadre pensé pour un style de vie urbain, dynamique et sécurisé.",
  "projects.sirena.features": [
    "Jardin",
    "02 cuisines (Africaine et américaine)",
    "Site accessible proche des commodités",
    "Architecture moderne",
    "Suite parentale",
    "Parking"
  ],
  "projects.sirena.programPlus": "Le + du programme",
  "projects.sirena.booking.fees": "",
  "projects.sirena.booking.deposit": "Mode VEFA - Acompte de 30% à la réservation",
  "projects.sirena.booking.balance": "Solde à libérer suivant l'état d'avancement des travaux",
  "projects.sirena.booking.financing": "Possibilité de financement bancaire",
  "projects.sirena.floor": "R+1",
  "projects.sirena.localisation": "Almadies",
  "projects.sirena.price": "350 000 000 FCFA",
  "projects.sirena.duration": "24 mois",
  "projects.sirena.reservationConditions": "Mode VEFA - Acompte de 30% à la réservation\nSolde à libérer suivant l'état d'avancement des travaux\nPossibilité de financement bancaire",
  "projects.sirena.title": "Résidences Sirena – Almadies",
  "projects.sirena.type": "Villa R+1 – 250 m²",
  "projects.title": "NOS RÉALISATIONS",
  "projects.tivaouane.address": "Logements de Tivaouane Peulh",
  "projects.tivaouane.description": "Ce projet de logements emblématique comprend des unités résidentielles, des espaces verts et des commodités modernes, mettant l'accent sur la durabilité et le bien-être. Les maisons offrent une belle luminosité, tandis que les espaces communs encouragent un mode de vie actif, créant un havre de paix urbain où modernité et tranquillité s'harmonisent.",
  "projects.tivaouane.features": [
    "Logements",
    "Infrastructures complètes",
    "Espaces publics aménagés",
    "Immeubles modernes R+5"
  ],
  "projects.tivaouane.programPlus": "Le + du programme",
  "projects.tivaouane.booking.fees": "Frais de dossier 250.000 FCFA",
  "projects.tivaouane.booking.deposit": "Acompte de 40 % à la réservation",
  "projects.tivaouane.booking.balance": "Solde à libérer suivant l'état d'avancement des travaux",
  "projects.tivaouane.booking.financing": "Possibilité de financement bancaire",
  "projects.tivaouane.floor": "R+5",
  "projects.tivaouane.localisation": "Tivaouane Peulh",
  "projects.tivaouane.price": "25 000 000 FCFA",
  "projects.tivaouane.reservationConditions": "Frais de dossier 250.000 FCFA\nMode VEFA - Acompte de 40 % à la réservation\nSolde à libérer suivant l'état d'avancement des travaux\nPossibilité de financement bancaire",
  "projects.tivaouane.title": "Logements - Tivaouane Peulh",
  "projects.tivaouane.type": "Villa – 150 m²",
  "projects.viewDetails": "Voir les détails",

  // =========================
  // CONTACT
  // =========================
  "contact.address.title": "Adresse",
  "contact.address.value": "Fann-Hock – Corniche face Cour Suprême, BP 1270, Dakar, Sénégal",
  "contact.coordinates": "Nos coordonnées",
  "contact.description": "Notre équipe reste à votre disposition pour répondre à toutes vos questions et vous accompagner dans vos projets.",
  "contact.directions": "Obtenir l’itinéraire",
  "contact.email.title": "E-mail",
  "contact.form.email": "E-mail",
  "contact.form.email.placeholder": "Votre e-mail",
  "contact.form.message": "Message",
  "contact.form.message.placeholder": "Votre message",
  "contact.form.name": "Nom complet",
  "contact.form.name.placeholder": "Votre nom",
  "contact.form.phone": "Téléphone",
  "contact.form.phone.placeholder": "Votre numéro de téléphone",
  "contact.form.send": "Envoyer le message",
  "contact.form.sending": "Envoi en cours...",
  "contact.form.subject": "Sujet",
  "contact.form.subject.information": "Demande d’information",
  "contact.form.subject.other": "Autre",
  "contact.form.subject.partnership": "Partenariat",
  "contact.form.subject.placeholder": "Votre sujet",
  "contact.form.subject.quote": "Demande de devis",
  "contact.form.title": "Envoyez-nous un message",
  "contact.headquarters": "Siège social SOCABEG",
  "contact.hero.subtitle": "Notre équipe est à votre écoute pour répondre à toutes vos questions",
  "contact.hero.title": "Contactez-nous pour démarrer\nune collaboration prometteuse",
  "contact.highlight": "CONTACTEZ-NOUS",
  "contact.hours.title": "Horaires d’ouverture",
  "contact.hours.value": "Lundi - Vendredi : 8h - 18h\nSamedi & Dimanche : Fermé",
  "contact.location.title": "Notre localisation",
  "contact.phone.title": "Téléphone / Fax",
  "contact.social": "Suivez-nous",
  "contact.title": "CONTACT",

  // =========================
  // FOOTER
  // =========================
  "footer.about": "À propos",
  "footer.achievements": "Nos réalisations",
  "footer.company": "SOCIÉTÉ D'AMÉNAGEMENT DE BÂTIMENT ET D'ÉTUDES GÉNÉRALES - BÂTIR ENSEMBLE L'AVENIR DU SÉNÉGAL",
  "footer.construction": "BTP",
  "footer.contact": "Contact",
  "footer.description": "Entreprise sénégalaise de BTP, promotion immobilière et mines.",
  "footer.group": "LE GROUPE",
  "footer.join": "Nous rejoindre",
  "footer.legal": "Mentions légales",
  "footer.mining": "Mines",
  "footer.realEstate": "Promotion immobilière",
  "footer.rights": "Tous droits réservés",
  "footer.usefulLinks": "LIENS UTILES",
  "footer.legal_column": "LEGAL",
  "footer.privacy": "Politique de Confidentialité",

  // =========================
  // MENTIONS LÉGALES
  // =========================
  "legal.title": "Mentions légales",
  "legal.editor.title": "Éditeur du site",
  "legal.editor.company": "Raison sociale",
  "legal.editor.legalForm": "Forme juridique",
  "legal.editor.address": "Siège social",
  "legal.editor.phone": "Téléphone",
  "legal.editor.email": "Email",
  "legal.publication.title": "Responsable de la publication",
  "legal.publication.responsible": "Responsable",
  "legal.development.title": "Développement du site",
  "legal.development.text": "Site conçu et développé par",
  "legal.hosting.title": "Hébergement",
  "legal.hosting.text": "Le site est hébergé par OVH.",
  "legal.intellectual.title": "Propriété intellectuelle",
  "legal.intellectual.text1": "L'ensemble de ce site relève de la législation sénégalaise et internationale sur le droit d'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.",
  "legal.intellectual.text2": "La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est formellement interdite sauf autorisation expresse du directeur de la publication.",
  "legal.liability.title": "Limitation de responsabilité",
  "legal.liability.text1": "SOCABEG s'efforce d'assurer au mieux de ses possibilités l'exactitude et la mise à jour des informations diffusées sur ce site, dont elle se réserve le droit de corriger, à tout moment et sans préavis, le contenu.",
  "legal.liability.text2": "SOCABEG décline toute responsabilité :",
  "legal.liability.point1": "Pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur le site.",
  "legal.liability.point2": "Pour tous dommages résultant d'une intrusion frauduleuse d'un tiers ayant entraîné une modification des informations mises à la disposition sur le site.",
  "legal.liability.point3": "Et plus généralement pour tous dommages, directs ou indirects, qu'elles qu'en soient les causes, origines, natures ou conséquences.",
  "legal.links.title": "Liens hypertextes",
  "legal.links.text": "La création de liens hypertextes vers le site www.socabeg.com est soumise à l'accord préalable du Directeur de la Publication. SOCABEG n'est en aucun cas responsable du contenu des sites qui font l'objet d'un lien hypertexte à partir du site www.socabeg.com.",
  "legal.applicable.title": "Droit applicable",
  "legal.applicable.text": "Le site www.socabeg.com et son contenu sont régis par le droit sénégalais. Tout litige relatif à ce site sera de la compétence exclusive des tribunaux sénégalais.",

  // =========================
  // POLITIQUE DE CONFIDENTIALITÉ
  // =========================
  "privacy.title": "Politique de confidentialité",
  "privacy.lastUpdate": "Dernière mise à jour",
  "privacy.introduction.title": "Introduction",
  "privacy.introduction.text1": "SOCABEG s'engage à protéger la vie privée des utilisateurs de son site web. Cette politique de confidentialité explique comment nous collectons, utilisons, divulguons et protégeons vos informations personnelles lorsque vous visitez notre site web.",
  "privacy.introduction.text2": "En utilisant notre site, vous acceptez les pratiques décrites dans la présente politique de confidentialité.",
  "privacy.collection.title": "Collecte d'informations",
  "privacy.collection.intro": "Nous collectons les types d'informations suivants :",
  "privacy.collection.provided.title": "Informations que vous nous fournissez",
  "privacy.collection.provided.intro": "Lorsque vous remplissez un formulaire sur notre site, nous pouvons collecter des informations personnelles telles que :",
  "privacy.collection.provided.item1": "Nom et prénom",
  "privacy.collection.provided.item2": "Adresse e-mail",
  "privacy.collection.provided.item3": "Numéro de téléphone",
  "privacy.collection.provided.item4": "Adresse postale",
  "privacy.collection.provided.item5": "Toute autre information que vous choisissez de nous fournir",
  "privacy.collection.automatic.title": "Informations collectées automatiquement",
  "privacy.collection.automatic.intro": "Lorsque vous visitez notre site, nous pouvons collecter automatiquement certaines informations, notamment :",
  "privacy.collection.automatic.item1": "Adresse IP",
  "privacy.collection.automatic.item2": "Type de navigateur",
  "privacy.collection.automatic.item3": "Pages visitées",
  "privacy.collection.automatic.item4": "Temps passé sur le site",
  "privacy.collection.automatic.item5": "Informations sur l'appareil utilisé",
  "privacy.usage.title": "Utilisation des informations",
  "privacy.usage.intro": "Nous utilisons les informations collectées pour :",
  "privacy.usage.item1": "Fournir, exploiter et maintenir notre site web",
  "privacy.usage.item2": "Répondre à vos demandes et questions",
  "privacy.usage.item3": "Vous envoyer des informations sur nos services",
  "privacy.usage.item4": "Améliorer notre site web et nos services",
  "privacy.usage.item5": "Analyser l'utilisation du site pour améliorer nos offres",
  "privacy.usage.item6": "Détecter et prévenir les fraudes",
  "privacy.sharing.title": "Partage des informations",
  "privacy.sharing.intro": "Nous ne vendons, n'échangeons ni ne louons vos informations personnelles à des tiers. Nous pouvons partager vos informations dans les situations suivantes :",
  "privacy.sharing.item1": "Avec des prestataires de services qui nous aident à exploiter notre site",
  "privacy.sharing.item2": "Pour se conformer à la loi ou répondre à une procédure judiciaire",
  "privacy.sharing.item3": "Pour protéger nos droits, notre propriété ou notre sécurité",
  "privacy.sharing.item4": "En cas de fusion, acquisition ou vente d'actifs, auquel cas vous en serez informé",
  "privacy.retention.title": "Conservation des données",
  "privacy.retention.text": "Nous conservons vos informations personnelles aussi longtemps que nécessaire pour atteindre les objectifs décrits dans cette politique de confidentialité, sauf si une période de conservation plus longue est requise ou permise par la loi.",
  "privacy.rights.title": "Vos droits",
  "privacy.rights.intro": "Vous disposez de certains droits concernant vos informations personnelles, notamment :",
  "privacy.rights.item1": "Le droit d'accéder à vos informations personnelles",
  "privacy.rights.item2": "Le droit de rectifier des informations inexactes",
  "privacy.rights.item3": "Le droit de demander la suppression de vos informations",
  "privacy.rights.item4": "Le droit de vous opposer au traitement de vos informations",
  "privacy.rights.item5": "Le droit à la portabilité des données",
  "privacy.rights.contact": "Pour exercer ces droits, veuillez nous contacter à l'adresse indiquée ci-dessous.",
  "privacy.security.title": "Sécurité des données",
  "privacy.security.text": "Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos informations personnelles contre tout accès non autorisé, altération, divulgation ou destruction.",
  "privacy.changes.title": "Modifications de la politique de confidentialité",
  "privacy.changes.text": "Nous pouvons mettre à jour cette politique de confidentialité de temps à autre. La date de la dernière mise à jour sera indiquée en haut de cette page. Nous vous encourageons à consulter régulièrement cette politique pour rester informé de la façon dont nous protégeons vos informations.",
  "privacy.contact.title": "Nous contacter",
  "privacy.contact.intro": "Si vous avez des questions concernant cette politique de confidentialité, veuillez nous contacter à :",
  "privacy.contact.email": "Email",
  "privacy.contact.phone": "Téléphone",
  "privacy.contact.address": "Adresse",

  // =========================
  // OTHER
  // =========================
  "notFound.backHome": "Retour à l’accueil",
  "notFound.contact": "Pour toute information, veuillez nous contacter :",
  "notFound.email": "E-mail :",
  "notFound.message": "Oups ! La page que vous recherchez n’existe pas ou a été déplacée.",
  "notFound.phone": "Téléphone :",
  "notFound.title": "Page non trouvée",
  "page.careers.title": "Carrières | SOCABEG",
  "page.privacy.title": "Politique de confidentialité | SOCABEG",
  "page.projet.title": "Projet | SOCABEG",
  "page.realisations.title": "Réalisations | SOCABEG",
  "page.terms.title": "Conditions d'utilisation | SOCABEG",
  "page.underConstruction.title": "En construction | SOCABEG",
  "realEstateDetail.amenities": "Équipements et services",
  "realEstateDetail.backToList": "Retour à la liste des projets",
  "realEstateDetail.booking.terms": "Conditions de réservation",
  "realEstateDetail.booking.title": "Réserver maintenant",
  "realEstateDetail.contactInfo": "Informations de contact",
  "realEstateDetail.contactUs": "Nous contacter",
  "realEstateDetail.features": "Caractéristiques",
  "realEstateDetail.location": "Localisation",
  "realEstateDetail.noAmenities": "Aucun équipement spécifique n'est renseigné pour ce projet.",
  "realEstateDetail.price": "Prix ( Hors frais de notaire )",
  "realEstateDetail.projectDescription": "Description du projet",
  "realEstateDetail.projectNotFound": "Projet non trouvé",
  "realEstateDetail.viewOnGoogleMaps": "Voir sur Google Maps",
  "superficie": "Superficie",
  "naturePapier": "Nature Papier",
  "statut": "Statut",
  "underConstruction.contact": "Pour toute information, veuillez nous contacter :",
  "underConstruction.email": "E-mail :",
  "underConstruction.message": "Cette page est en cours de développement. Revenez bientôt pour découvrir son contenu. Merci de votre patience.",
  "underConstruction.phone": "Téléphone :",
  "underConstruction.title": "En construction"
};

export default frTranslations;
